import { memo } from 'react';

import './styles.scss';

const Placeholder = () => (
  <div className='lb-post lb-matchevents lb-dummy'>
    <div className='lb-post-time'>
      <div className='dummy-time' />
    </div>
    <div className='lb-post-wrap'>
      <div className='lb-content'>
        <div className='dummy-row-1' />
        <div className='dummy-row-2' />
        <div className='dummy-row-3' />
        <div className='social-dummy-wrap'>
          <div className='dummy-social-1' />
          <div className='dummy-social-2' />
        </div>
      </div>
    </div>
  </div>
);

export default memo(Placeholder);
